import beadmin from "./beadmin";
import balance from "./balance";
import collection from "./collection";
import collectionData from "./collectionData";
import command from "./command";
import company from "./company";
import companyFrontEndPageDefaultParam from "./companyFrontEndPageDefaultParam";
import companyGlobalParam from "./companyGlobalParam";
import companyRepository from "./companyRepository";
import cost from "./cost";
import dealer from "./dealer";
import doorControl from "./doorControl";
import employees from "./employees";
import energyPlan from "./energyPlan";
import entering from "./entering";
import enumClass from "./enumClass";
import event from "./event";
import messageServer from "./messageServer";
import file from "./file";
import frontEndDIYComponent from "./frontEndDIYComponent";
import frontEndPage from "./frontEndPage";
import frontEndPageCustomParam from "./frontEndPageCustomParam";
import kpi from "./kpi";
import log from "./log";
import login from "./login";
import manufacturer from "./manufacturer";
import measure from "./measure";
import measuring from "./measuring";
import measuringRaw from "./measuringRaw";
import measuringServer from "./measuringServer";
import measuringClassification from "./measuringClassification";
import menu from "./menu";
import notifyMsg from "./notifyMsg";
import orgStructNode from "./orgStructNode";
import proximityCard from "./proximityCard";
import power from "./power";
import quantity from "./quantity";
import rentalArea from "./rentalArea";
import report from "./report";
import role from "./role";
import statement from "./statement";
import subsystem from "./subsystem";
import timeSegments from "./timeSegments";
import trigger from "./trigger";
import user from "./user";
import view from "./view";
import tmp from "./tmp";
import contract from "./contract";
import electricOperations from "./electricOperations";
import predict from "./predict";
import nhtj from "./nhtj";
import operatingPlatform from "./operatingPlatform";
import dataUpload from "./dataUpload";
import workOrder from "./workOrder";

export default {
  beadmin,
  balance,
  collection,
  collectionData,
  command,
  company,
  companyFrontEndPageDefaultParam,
  companyGlobalParam,
  companyRepository,
  cost,
  dealer,
  doorControl,
  employees,
  energyPlan,
  entering,
  enumClass,
  event,
  messageServer,
  file,
  frontEndDIYComponent,
  frontEndPage,
  frontEndPageCustomParam,
  kpi,
  log,
  login,
  manufacturer,
  measure,
  measuring,
  measuringRaw,
  measuringServer,
  measuringClassification,
  menu,
  notifyMsg,
  orgStructNode,
  proximityCard,
  power,
  quantity,
  rentalArea,
  report,
  role,
  statement,
  subsystem,
  timeSegments,
  trigger,
  user,
  view,
  tmp,
  contract,
  electricOperations,
  predict,
  nhtj,
  operatingPlatform,
  dataUpload,
  workOrder,
  version: "v2.2.18 alpha",
};
